import type {
  AiChat,
  AiChatCreateForm,
  AiChatDeleteResponse,
  AiChatDetailResponse,
  AiChatMutationResponse,
  AiChatUpdateForm,
  AiChatsGetParams,
  AiChatsResponse,
} from 'src/types';
import axios, { ENDPOINTS } from 'src/utils/axios';

const chatUrl = (id: AiChat['id']) => `${ENDPOINTS.ai.chats}/${id}`;

export const getAiChats = async (params: AiChatsGetParams) => {
  const response = await axios.get<AiChatsResponse>(ENDPOINTS.ai.chats, { params });
  return response.data;
};

export const getAiChat = async (id: AiChat['id']) => {
  const response = await axios.get<AiChatDetailResponse>(chatUrl(id));
  return response.data;
};

export const createAiChat = async (data: AiChatCreateForm) => {
  const response = await axios.post<AiChatMutationResponse>(ENDPOINTS.ai.chats, data);
  return response.data;
};

export const updateAiChat = async (data: AiChatUpdateForm) => {
  const { id, ...body } = data;
  const response = await axios.put<AiChatMutationResponse>(chatUrl(id), body);
  return response.data;
};

export const deleteAiChat = async (id: AiChat['id']) => {
  const response = await axios.delete<AiChatDeleteResponse>(chatUrl(id));
  return response.data;
};
